/** Amounts arrive in kobo. Shown as ₦1,300,000, with kobo only when there are some. */
export const money = (minor: number | null | undefined, currency = 'NGN'): string => {
  if (minor === null || minor === undefined || Number.isNaN(minor)) {
    return '';
  }
  const major = minor / 100;
  const whole = Number.isInteger(major);
  const formatted = major.toLocaleString('en-NG', {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: 2,
  });
  const symbol = currency === 'NGN' ? '₦' : `${currency} `;
  return `${symbol}${formatted}`;
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** A YYYY-MM-DD (or ISO) date as 24 Nov, 2026. */
export const date = (value: string | null | undefined): string => {
  if (!value) {
    return '';
  }
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) {
    return value;
  }
  const [, year, month, day] = match;
  return `${Number(day)} ${MONTHS[Number(month) - 1]}, ${year}`;
};

/** 6 MONTHS → 6 months; 1 MONTHS → 1 month. */
export const tenor = (value: number, unit: string): string => {
  const base = (unit || '').toLowerCase().replace(/s$/, '');
  return `${value} ${base}${value === 1 ? '' : 's'}`;
};

/** MONTHLY → Monthly. */
export const titleCase = (value: string | undefined): string =>
  value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase().replace(/_/g, ' ') : '';

export const fileSize = (bytes: number): string => {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
